import styled, { css } from 'styled-components';

export const ExternalEntityMappingPanelRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const MappingTablesHost = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  border: none;
`;

export const IntroText = styled.div`
  color: ${({ theme }) => theme.colors.blacks.ipBlack1};
  font: ${({ theme }) => theme.fonts.textInterRegular12Height20};
  white-space: pre-line;
`;

export const CellContent = styled.div`
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const DropdownContainer = styled.div`
  height: 100%;
  position: relative;
  width: 100%;

  > div:first-child > div:first-child {
    border-radius: 0;
    border-style: none;
    height: 100%;
  }

  ${({ $isError, theme }) =>
    $isError &&
    css`
      > div:first-child > div:first-child > div {
        color: ${theme.colors.infoRed1} !important;
      }
    `}
`;

export const RowActions = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  padding-top: 4px;
`;

export const RemoveRowButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  padding: 4px;
  width: 32px;

  &:hover {
    opacity: 0.7;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.35;
  }
`;

export const AddRowButton = styled.button`
  align-self: flex-start;
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.greys.darkest};
  cursor: pointer;
  font: ${({ theme }) => theme.fonts.textInterRegular14Height20};
  margin-top: 4px;
  padding: 4px 0;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

export const CustomerItemContent = styled.span`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

export const CustomerItemId = styled.span`
  color: ${({ theme }) => theme.colors.greys.darker};
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
